import styled from "styled-components";


export const Wrapper = styled.div`

background: var(--White-100, #FFF);
padding: 20px 58px;
width: 100%;
display: flex;
justify-content: space-between;
align-items: center;
header{
    width: 100%;
    img{
        height: 50px;
        width: 130px;
        object-fit: fill;
    }
}
`

export const RightSide = styled.div`
display: flex;
`

export const LoginLink = styled.div`
    cursor: pointer;
    color: var(--font-color-blue2555ef);
    font-weight: var(--font-weight-bold);
`
